import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'

const useToolsStore = create((set, get) => ({
    isMobile: false,
    isTablet: false,
    isPortrait: false,
    mobileComponent: "trades",

    setIsMobile: (status) => {
        set({isMobile: status})
    },
    setIsTablet: (status) => {
        set({isTablet: status})
    },
    setIsPortrait: (status) => {
        set({isPortrait: status})
    },
    setMobileComponent: (component) => {
        set(produce(state => { state.mobileComponent = component }));
    },
}))

export default useToolsStore